import styled from 'styled-components'
import { SpecialButtonLink } from '@chegg-wt/core/theme/fanta/button'

export const Header = styled.h1`
  margin: 0.67em 0;
  line-height: 1.1;
  color: inherit;
  margin-top: 20px;
  font-size: 20px;
  margin-bottom: 10px;
  font-weight: 700;
`

export const Container = styled.div`
  font-family: Aspira;
  color: black;
  font-size: 14px;
  line-height: 20px;
  box-sizing: border-box;
  text-align: center;
`

export const OrderedList = styled.ol`
  list-style-type: decimal;
  font-family: Aspira;
  margin: 0 5px 10px 5px;
  padding: 5px 20px;
  border-top: 1px solid #c8d0d7;
  border-bottom: 1px solid #c8d0d7;
`

export const ListItem = styled.li`
  text-align: left;
`
export const Footer = styled.div`
  line-height: 20px;
  text-align: center;
`

export const RadioInput = styled.input`
  width: auto;
  overflow: hidden;
  padding: 0;
  line-height: normal;
  border: 0;
  margin: 7px;
`

export const SubmitButton = styled(SpecialButtonLink)`
  width: auto;
  border: 0;
  border-bottom: 2px solid #e42f00;
  border-radius: 7px;
  display: inline-block;
  cursor: pointer;
  text-align: center;
  vertical-align: middle;
  margin: 7px;
`

export const DataContainer = styled.div`
  width: fit-content;
  margin: auto;
  text-align: center;
`
